const InstancesListHeader = () => {
    return (
        <thead className="practice-list-header">
            <th className="practice-list-select-col">Select</th>
            <th className="practice-list-instance-id-col">Instance ID</th>
            <th className="practice-list-prac-name-col">Practice Name</th>
            <th className="practice-list-pims-col">PIMS</th>
            <th className="practice-list-pims-version-col">PIMS Version</th>
        </thead>
    );
};

export default InstancesListHeader;
